import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Line = styled.div`
  width: 100%;
  height: 1px;
  border: solid 1px ${ColorPalette.HEX.BrightGray};
`;

export const PreferencesContainer = styled.div``;

export const MenuItem = styled.div`
  position: relative;
  display: flex;
  margin: 0 16px;
  height: 81px;
  align-items: center;
  border-top: solid 1px ${ColorPalette.HEX.BrightGray};
  cursor: pointer;
`;

export const ItemTitle = styled.div`
  margin-left: 10px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const Icon = styled.img`
  height: 100%;
`;

export const IconEdit = styled.img`
  cursor: pointer;
  right: 18px;
  position: absolute;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
`;
